import axiosTokenInstance from 'services/api/backoffice';
import {
  DETAIL_TRANSACTIONS_MERCADOPAGO,
  DETAIL_TRANSACTIONS_MERCADOPAGO_ERROR,
} from '_models/redux/types';

// Action function
export const detailMercadoPagoAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/mercadopago-transactions/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_MERCADOPAGO,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_MERCADOPAGO_ERROR,
      response: e || {},
    });
  }
};
